<ng-container *ngIf="visible">
    <mat-progress-bar [color]="fuseConfig.layout.progressbar.customClass" [bufferValue]="bufferValue" [mode]="mode" [value]="value"></mat-progress-bar>

</ng-container>
